import { FunctionComponent, Suspense, useCallback, useContext, useEffect, useRef } from "react"
import { RouteComponentProps, useParams } from "react-router-dom"
import OrderList from "overrides/theme/wom/base/components/Contractor/Core/Order/OrderList"
import OrderContainerStyled from "components/Core/Order/OrderList.styled"
import useGetSgsByStatus from "hooks/Contractor/useGetSgsByStatus"
import IPage from "interfaces/IPage"
import SkeletonGrid from "components/Commons/Skeleton/SkeletonGrid"
import BackBotton from "components/Commons/BackBotton/BackBotton"
import Paginate from "components/Commons/Pagination/Paginate"
import OrderFilterDate from "components/Core/Order/FilterDate/OrderFilterDate"
import ErrorHandler from "components/Commons/Error/ErrorHandler"
import SearchForm from "overrides/theme/wom/base/components/SearchForm/SearchForm"
import { ISearchResults } from "interfaces/ISearchResults"
import SortOrder from "components/Core/Order/Sort/SortOrder"
import { AuthContext } from "context/context/AuthContext"
import { clients } from "webapp-clients/Clients"
import { GlobalContext } from "context/context/GlobalContext"
import ContractorEmptyState from "components/Commons/EmptyState/ContractorEmptyState"

const ContractorOrderScreen: FunctionComponent<IPage & RouteComponentProps<any>> = (props: any) => {
  
  // Obtener el parámetro :status :type de la URL
  const { type } = useParams<{ type: string }>()
  const { status } = useParams<{ status: string }>()

  const {
    state: { user },
  } = useContext(AuthContext)

  const { userSearch, errorHander } = useContext(GlobalContext)

  useEffect(() => {
    userSearch?.dispatch({ option: "", value: "" })
    //eslint-disable-next-line
  }, [user])

  const {
    ordersGroup,
    loading,
    setPage,
    maxPage,
    onSelectedRangeDate,
    page,
    setSearch,
    onChangeSortDate,
    handleChangeCustomFilters,
    isEmpty,
  } = useGetSgsByStatus(type, status)

  const client = clients[user?.mainGroup.id as keyof typeof clients]
  const CustomFilters = client["CustomFilters" as keyof typeof client]

  const refElemOrders = useRef<HTMLDivElement>(null)

  const handleClickPage = (pageSeleted: number) => {
    setPage(pageSeleted)
  }

  const handleClickSearch = useCallback(
    ({ query, optionFilter }: ISearchResults) => {
      if (optionFilter) {
        if (query === "") {
          setSearch({
            [optionFilter]: undefined,
          })
          userSearch?.dispatch({ option: "", value: "" })
        } else {
          setSearch({
            [optionFilter]: query,
          })
          userSearch?.dispatch({ option: optionFilter, value: query })
        }
      }
    },
    //eslint-disable-next-line
    [setSearch],
  )

  return (
    <div ref={refElemOrders}>
      {errorHander?.state?.hasError ? (
        <ErrorHandler 
          code={errorHander.state.code} 
          message={errorHander.state.message || "Ha ocurrido un error inesperado"} 
        />
      ) : (
        <>
          <BackBotton>
            <OrderFilterDate onSelectedRangeDate={onSelectedRangeDate} />
          </BackBotton>
          <SearchForm onClickSearch={handleClickSearch} isLoading={loading} />
          <OrderContainerStyled hasCustomFilters={!!CustomFilters}>
            <section className="section-filters">
              {CustomFilters && (
                <Suspense fallback={null}>
                  <CustomFilters onChangeCustomFilters={handleChangeCustomFilters} />
                </Suspense>
              )}
              <SortOrder handleChangeSort={onChangeSortDate} disabled={loading} />
            </section>

            {loading ? (
              <SkeletonGrid count={3} isGroupOrder={true} />
            ) : (
              <>
                {isEmpty ? (
                  <ContractorEmptyState />
                ) : ordersGroup ? (
                  <>
                    <OrderList ordersGroup={ordersGroup} />
                    {maxPage > 1 && (
                      <Paginate
                        pageCount={maxPage}
                        onChangePage={handleClickPage}
                        elementFocus={refElemOrders}
                        pageInit={page}
                      />
                    )}
                  </>
                ) : (
                  <ErrorHandler message="Sin resultados para esta busqueda" />
                )}
              </>
            )}
          </OrderContainerStyled>
        </>
      )}
    </div>
  )
}

export default ContractorOrderScreen
